import React from 'react'

import { concatStyles } from 'utils'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons/faChevronRight'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { AccessoryLabel } from './AccessoryLabel'

const ACCESSORY_STYLES =
  'flex flex-row m-0 box-border min-w-0 max-w-full flex-grow'

const BUTTON_STYLES = 'mt-4 text-xl ml-auto w-8 h-8'

export interface IAccessoryViewProps {
  onClick?: React.MouseEventHandler
  label?: string
  className?: string
  icon?: IconDefinition
}

/**
 * An accessory adjacent to any content item contents.
 * @param props Configuration for the item.
 */
export const AccessoryView: React.FC<IAccessoryViewProps> = ({
  label,
  className,
  icon = faChevronRight,
  onClick: handleOnClick,
}) => {
  return (
    <div className={concatStyles([ACCESSORY_STYLES, className])}>
      <AccessoryLabel>{label}</AccessoryLabel>
      <button className={BUTTON_STYLES} onClick={handleOnClick}>
        <FontAwesomeIcon icon={icon} />
      </button>
    </div>
  )
}
